// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"485":"29b77ac48e37a975","873":"10018aae4993f408"}[chunkId] + ".js";
};